var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationOverwrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4c-5.492 0-10 4.508-10 10v17.75l-2.875-2.875-2.813 2.844L12 39.406l7.688-7.687-2.813-2.813L14 31.75V14c0-3.309 2.691-6 6-6h11V4Zm18 6.594-7.719 7.719 2.844 2.812L36 18.25V36c0 3.309-2.691 6-6 6H19v4h11c5.492 0 10-4.508 10-10V18.25l2.875 2.875 2.813-2.844Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationOverwrite);
export default __webpack_public_path__ + "static/media/operationOverwrite.8668f9b5f12a10c5d1ded7241a22b18b.svg";
export { ForwardRef as ReactComponent };